<div class="container-fluid">
  <app-pagetitle title="Tableau de bord" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>


  <div class="row">

    <div class="col-md-4">

      <div class="row">
        <div class="col-lg-12" [routerLink]="" (click)="openApp()" routerLinkActive="router-link-active" >
          <div class="card bg-danger text-white-120">
            <div class="card-body">
              <h5 class="mt-0 mb-4 text-white" style="text-align: center;"><i class="mdi mdi-air-horn mr-3"></i>MODULE D'ALERTE ET D'INTERVENTION</h5>
            </div>
          </div>
        </div>
    </div>
    </div>
 
    <div class="col-md-4"></div>

    <div class="col-md-4">

      <div class="row">
        <div class="col-lg-12" [routerLink]="['/affectation']" routerLinkActive="router-link-active" >
          <div class="card bg-info text-white-120">
            <div class="card-body">
              <h5 class="mt-0 mb-4 text-white" style="text-align: center;"><i class="mdi mdi-account-group mr-3"></i>Feuille de garde</h5>
            </div>
          </div>
        </div>
    </div>
    </div>
  </div>

  <div class="row">

    <div class="col-md-4">

      <div class="row">
        <div class="col-lg-12" [routerLink]="['/planning/planning']" routerLinkActive="router-link-active" >
          <div class="card bg-primary text-white-120">
            <div class="card-body">
              <h5 class="mt-0 mb-4 text-white" style="text-align: center;"><i class="mdi mdi-dots-vertical mr-3"></i>Planning</h5>
            </div>
          </div>
        </div>
    </div>
    </div>

    <div class="col-md-4"><img class="main-logo" src="assets/images/logo-sm-dark.png" alt=""></div>

    <div class="col-md-4">

      <div class="row">
        <div class="col-lg-12" [routerLink]="['/activites/soin']" routerLinkActive="router-link-active" >
          <div class="card bg-success text-white-120">
            <div class="card-body">
              <h5 class="mt-0 mb-4 text-white" style="text-align: center;"><i class="mdi mdi-medical-bag mr-3"></i>Soins</h5>
            </div>
          </div>
        </div>
    </div>
    </div>
  </div>

  <div class="row">

    <div class="col-md-4">

      <div class="row">
        <div class="col-lg-12" [routerLink]="['/maincourante']" routerLinkActive="router-link-active" >
          <div class="card bg-warning text-white-120">
            <div class="card-body">
              <h5 class="mt-0 mb-4 text-white" style="text-align: center;"><i class="mdi mdi-dots-vertical mr-3"></i>Main Courante</h5>
            </div>
          </div>
        </div>
    </div>
    </div>

    <div class="col-md-4"></div>

    <div class="col-md-4">

      <div class="row">
        <div class="col-lg-12" [routerLink]="['/agenda']" routerLinkActive="router-link-active" >
          <div class="card bg-secondary text-white-120">
            <div class="card-body">
              <h5 class="mt-0 mb-4 text-white" style="text-align: center;"><i class="mdi mdi-dots-vertical mr-3"></i>Agenda</h5>
            </div>
          </div>
        </div>
    </div>
    </div>
  </div>

  <div class="row">

    <div class="col-md-4">

      <div class="row">
        <div class="col-lg-12" [routerLink]="['/interventions']" routerLinkActive="router-link-active" >
          <div class="card bg-info text-white-120">
            <div class="card-body">
              <h5 class="mt-0 mb-4 text-white" style="text-align: center;"><i class="mdi mdi-dots-vertical mr-3"></i>Interventions en cours</h5>
            </div>
          </div>
        </div>
    </div>
    </div>
    <div class="col-md-4">

      <div class="row">
        <div class="col-lg-12" [routerLink]="['/roulage']" routerLinkActive="router-link-active" >
          <div class="card bg-danger text-white-120">
            <div class="card-body">
              <h5 class="mt-0 mb-4 text-white" style="text-align: center;"><i class="mdi mdi-dots-vertical mr-3"></i>Patrouille/Roulage</h5>
            </div>
          </div>
        </div>
    </div>
    </div>
    <div class="col-md-4">

      <div class="row">
        <div class="col-lg-12" [routerLink]="['/liste']" routerLinkActive="router-link-active" >
          <div class="card bg-primary text-white-120">
            <div class="card-body">
              <h5 class="mt-0 mb-4 text-white" style="text-align: center;"><i class="mdi mdi-dots-vertical mr-3"></i>Liste Personnels</h5>
            </div>
          </div>
        </div>
    </div>
    </div>
  </div>


  <!-- <div class="row accueil widget-stats">
    <div class="col-md-3 stats-container"><div class="stats-participations">
        <a class="stats-link" name="StatSection" onclick="" data-original-title="" title="">
            <div class="stats-header">
                <div><i class="fa fa-user fa-xl stats-participations-icon stats-icon" data-original-title="" title=""></i></div>
                <div class="stats-title"> Mes Participations<br><span class="stats-subtitle" data-original-title="" title="">2021</span></div>
            </div>
        
            <div class="stats-numbers">
                <div class="stats-number">Total <span title="" data-original-title="Ce widget montre le nombre total de mes participation depuis le début de l'année en cours et le nombre de mes participations sur des activités en cours ou à venir">32</span></div>
                <div>A venir <span title="" data-original-title="Ce widget montre le nombre total de mes participation depuis le début de l'année en cours et le nombre de mes participations sur des activités en cours ou à venir">0</span></div>
            </div>
        </a>
    </div></div>
    
    <div class="col-md-3 stats-container"><div class="stats-activities">
        <a class="stats-link" name="StatSection" onclick="" data-original-title="" title="">
            <div class="stats-header">
                <div><i class="fa fa-calendar-alt stats-activities-icon stats-icon" data-original-title="" title=""></i></div>
                <div class="stats-title">Activités<br><span class="stats-subtitle" data-original-title="" title="">Centre de secours demo</span></div>
            </div>
        
            <div class="stats-numbers">
                <div class="stats-number">Mois <span title="" data-original-title="Ce widget montre le nombre d'activités organisés au niveau Centre de secours demo depuis le début du mois en cours et depuis le début du trimestre en cours">1</span></div>
                <div>Trimestre <span title="" data-original-title="Ce widget montre le nombre d'activités organisés au niveau Centre de secours demo depuis le début du mois en cours et depuis le début du trimestre en cours">60</span></div>
            </div>
        </a>
    </div></div>

    <div class="col-md-3 stats-container"><div class="stats-members"> 
        <a class="stats-link" name="StatSection" onclick="" data-original-title="" title="">
            <div class="stats-header">
                <div><i class="fa fa-user-plus fa-1x stats-members-icon stats-icon" data-original-title="" title=""></i></div>
                <div class="stats-title"> Nouveaux Membres<br><span class="stats-subtitle" data-original-title="" title="">Centre de secours demo</span></div>
            </div>
        
            <div class="stats-numbers">
                <div class="stats-number">Mois <span title="" data-original-title="Ce widget montre le nombre de nouveaux membres actifs recrutés dans Centre de secours demo depuis le début du mois en cours et depuis le début du trimestre en cours">0</span></div>
                <div>Trimestre <span title="" data-original-title="Ce widget montre le nombre de nouveaux membres actifs recrutés dans Centre de secours demo depuis le début du mois en cours et depuis le début du trimestre en cours">1</span></div>
            </div>
        </a>
    </div></div>

    <div class="col-md-3 stats-container"><div class="stats-taches"> 
       <div class="stats-header">
           <div><i class="fa fa-bell fa-lg stats-taches-icon" data-original-title="" title=""></i></div>
           <div class="stats-title">Tâches<br><span class="stats-subtitle" title="" data-original-title="Ce widget indique le nombre d'éléments à surveiller, valider ou corriger qui apparaissent dans les autres widgets. Ceci inclut selon la configuration de l'application et vos permissions 
    le contrôle des véhicules (révisions, assurances, CT), des consommables (périmés, en dessous du stock minimum), 
    des CP à valider, des Horaires à vérifier, des remplacements à approuver, des champs manquants sur ma propre fiche personnel">Mes Alarmes</span></div>
       </div>
        
        <div class="stats-numbers">
            <div>Total <span title="" data-original-title="Ce widget indique le nombre d'éléments à surveiller, valider ou corriger qui apparaissent dans les autres widgets. Ceci inclut selon la configuration de l'application et vos permissions 
    le contrôle des véhicules (révisions, assurances, CT), des consommables (périmés, en dessous du stock minimum), 
    des CP à valider, des Horaires à vérifier, des remplacements à approuver, des champs manquants sur ma propre fiche personnel">7</span></div>
        </div>
    </div></div>
</div> -->



<!-- 
<div class="row">


  
  <div class="col-sm-4">
    <div class="row accueil"><div class="col-sm-12">
<div class="card hide card-default">
<div class="card-header">
<div class="card-title"><strong></strong></div>

</div>
<div class="card-body">
<div class="row accueil" style="margin-top: -30px"><a href="upd_personnel.php?from=inscriptions&amp;tab=1&amp;pompier=245" data-original-title="" title=""><i class="fa fa-ellipsis-h fa-lg three-points-icon" data-original-title="" title=""></i></a><table class="noBorder" width="100%" style="padding: 15px 15px 0 15px"><tbody><tr data-original-title="" title=""><td width="30%"><a href="upd_personnel.php?from=inscriptions&amp;tab=1&amp;pompier=245" data-original-title="" title=""><img src="../../../assets/images/users/equipier1.jpg" class="rounded" width="110" data-original-title="" title=""></a></td><td width="70%" style="padding-left: 15px">

<div class="font widget-title" style="font-size: 1.35em;">
<a href="upd_personnel.php?pompier=245&amp;tab=1" data-original-title="" title="">Alain LE ROUX </a>
</div>
<div class="widget-text" style="font-size: 15px">Nº 245</div>
<div class="font profile-widget widget-title">section 2</div><br>
<div class="font widget-title">Mercredi 31 mars 2021 11:06</div><div class="widget-text">Semaine 13</div>
</td></tr></tbody></table><table class="noBorder profile-alerts separate" style="margin-left: 5px;width: 100%"></table></div>
</div>
</div></div><div class="col-sm-12">
<div class="card hide card-default">
<div class="card-header">
<div class="card-title"><strong>Ma section</strong></div>

</div>
<div class="card-body">
<div class="row accueil" style=""><table class="noBorder widget-table">
<tbody><tr data-original-title="" title=""><td colspan="4"><i class="fa fa-birthday-cake alert-icon alert-blue" style="font-size: 20px;" data-original-title="" title=""></i><span class="pl-2 font-weight-bolder" data-original-title="" title="">Anniversaire à souhaiter</span></td></tr>
<tr data-original-title="" title=""></tr><tr data-original-title="" title="">
<td width="50px">
    <a href="upd_personnel.php?pompier=228" data-original-title="" title="">
    <img src="../../../assets/images/users/equipier4.jpg" width="37" style="border-radius:20%;" data-original-title="" title=""></a>
</td>
<td class="widget-title">
    <a href="upd_personnel.php?pompier=228" data-original-title="" title="">Jérémy DURAND</a>
</td>
<td>
    <div class="widget-subtitle">02 avril</div>
</td>
<td>
    <span class="alert-label alert-violet mt-2" data-original-title="" title="">Après-demain</span>
</td>
</tr></tbody></table><table class="noBorder widget-table pt-3"></table></div>
</div>
</div></div><div class="col-sm-12">
<div class="card hide card-default">
<div class="card-header">
<div class="card-title"><strong>Consommable</strong></div>

</div>
<div class="card-body">
<div class="row accueil" style=""><a href="consommable.php?page=1" data-original-title="" title=""><i class="fa fa-ellipsis-h fa-lg three-points-icon" data-original-title="" title=""></i></a><table class="noBorder widget-table"><tbody><tr data-original-title="" title=""><td class="alert-orange alert-element"><div class="alert-justify"><div> <a class="widget-link" href="consommable.php?order=C_DATE_PEREMPTION&amp;filter0" title="" data-original-title="Cliquer pour voir les produits consommables"><span class="widget-title" data-original-title="" title="">Consommables</span><span class="widget-subtitle" data-original-title="" title=""><br>Bientôt périmés</span></a></div><a class="widget-link" href="consommable.php?order=C_DATE_PEREMPTION&amp;filter0" title="" data-original-title="Cliquer pour voir les produits consommables"><span class="text-warning-alert" style="color:#ffa800" data-original-title="" title="">1</span></a></div></td></tr></tbody></table><table class="noBorder widget-table"><tbody><tr data-original-title="" title=""><td class="alert-red alert-element"><div class="alert-justify"><div> <a class="widget-link" href="consommable.php?order=C_DATE_PEREMPTION&amp;filter0" title="" data-original-title="Cliquer pour voir les produits consommables"><span class="widget-title" data-original-title="" title="">Consommables</span><span class="widget-subtitle" data-original-title="" title=""><br>Périmés</span></a></div><a class="widget-link" href="consommable.php?order=C_DATE_PEREMPTION&amp;filter0" title="" data-original-title="Cliquer pour voir les produits consommables"><span class="text-warning-alert" style="color:#f64e60" data-original-title="" title="">1</span></a></div></td></tr></tbody></table><table class="noBorder widget-table"><tbody><tr data-original-title="" title=""><td class="alert-orange alert-element"><div class="alert-justify"><div> <a class="widget-link" href="consommable.php?order=C_DATE_PEREMPTION&amp;filter0" title="" data-original-title="Cliquer pour voir les produits consommables"><span class="widget-title" data-original-title="" title="">Consommables</span><span class="widget-subtitle" data-original-title="" title=""><br>En dessous du stock minimum</span></a></div><a class="widget-link" href="consommable.php?order=C_DATE_PEREMPTION&amp;filter0" title="" data-original-title="Cliquer pour voir les produits consommables"><span class="text-warning-alert" style="color:#ffa800" data-original-title="" title="">2</span></a></div></td></tr></tbody></table></div>
</div>
</div></div><div class="col-sm-12">
<div class="card hide card-default">
<div class="card-header">
<div class="card-title"><strong>Remplacement</strong></div>

</div>
<div class="card-body">
<div class="row accueil" style=""><a href="remplacements.php" data-original-title="" title=""><i class="fa fa-ellipsis-h fa-lg three-points-icon" data-original-title="" title=""></i></a><span class="no-content" data-original-title="" title="">Aucun remplacement en cours.</span></div>
</div>
</div></div><div class="col-sm-12">
<div class="card hide card-default">
<div class="card-header">
<div class="card-title"><strong>Horaire des salariés</strong></div>

</div>
<div class="card-body">
<div class="row accueil" style=""><span class="no-content" data-original-title="" title="">Pas d'horaires à valider</span></div>
</div>
</div></div><div class="col-sm-12">
<div class="card hide card-default">
<div class="card-header">
<div class="card-title"><strong>Demande de congés</strong></div>

</div>
<div class="card-body">
<div class="row accueil" style=""><a href="indispo_choice.php?tab=2&amp;page=1" data-original-title="" title=""><i class="fa fa-ellipsis-h fa-lg three-points-icon" data-original-title="" title=""></i></a><span class="no-content" data-original-title="" title="">Aucune demande de congé à valider</span></div>
</div>
</div></div> </div>
</div>

<div class="col-sm-4">
  <div class="row accueil"><div class="col-sm-12">
<div class="card hide card-default">
<div class="card-header">
<div class="card-title"><strong>Mes activités</strong></div>

</div>
<div class="card-body">
<div class="row accueil" style=""><span class="no-content" data-original-title="" title="">Aucune prochain participation prévue</span><a href="upd_personnel.php?from=inscriptions&amp;tab=4&amp;pompier=245&amp;type_evenement=ALL" data-original-title="" title=""><i class="fa fa-ellipsis-h fa-lg three-points-icon" data-original-title="" title=""></i></a></div>
</div>
</div></div><div class="col-sm-12">
<div class="card hide card-default">
<div class="card-header">
<div class="card-title"><strong></strong></div>

</div>
<div class="card-body">
<div class="row accueil" style="margin-top: -30px"><div class="timeline" style=""></div><div class="infos-principal-title"><a href="tableau_garde.php?tab=2&amp;mode_garde=1" title="" data-original-title="Voir les consignes en cours">Consignes opérationnelles</a><a href="tableau_garde.php?tab=2&amp;mode_garde=1" data-original-title="" title=""><i class="fa fa-ellipsis-h fa-lg infos-three-point-icon" data-original-title="" title=""></i></a></div><table class="noBorder"><tbody><tr data-original-title="" title=""><td class="infos-date">04-02-2021</td><td class="infos-content"><i class="infos-icon far fa-circle fa-lg" style="color:#1bc5bd;" title="" data-original-title="message information"></i><span class="infos-title" data-original-title="" title="">CCDF 792 en panne </span><br><strong>Un des moyens feu de forêt est à l'atelier départemental pour changement boîte de transfert. <span style="color: #ff0000;" data-original-title="" title="">Date de remise en service encore inconnue.</span></strong></td></tr></tbody></table><table class="noBorder"><tbody><tr data-original-title="" title=""><td class="infos-date">04-02-2021</td><td class="infos-content"><i class="infos-icon far fa-circle fa-lg" style="color:#1bc5bd;" title="" data-original-title="message information"></i><span class="infos-title" data-original-title="" title="">Nouvelle règle d'engagement risque COVID </span><br>Durant les périodes d'épidémie, de nouvelles rèles d'engagement du personnel sont mises à jour chaque semaine. Veuillez lire les notes de service.<a href="showfile.php?section=0&amp;evenement=0&amp;message=125&amp;file=eBrigade-COVID19.docx" data-original-title="" title=""><br>Pièce jointe</a></td></tr></tbody></table><div class="infos-principal-title" style="margin-top: 25px;padding-top: 20px"><a href="message.php?catmessage=amicale" title="" data-original-title="Voir les informations en cours">Actualités</a><a href="message.php?catmessage=amicale" data-original-title="" title=""><i class="fa fa-ellipsis-h fa-lg infos-three-point-icon" data-original-title="" title=""></i></a></div><table class="noBorder"><tbody><tr data-original-title="" title=""><td class="infos-date">31-01-2021</td><td class="infos-content"><i class="infos-icon far fa-circle fa-lg" style="color:#1bc5bd;" title="" data-original-title="message information"></i><span class="infos-title" data-original-title="" title="">Nouvelle organisation de la section des SPV</span><br>sans texte<a href="showfile.php?section=0&amp;evenement=0&amp;message=102&amp;file=Note_dapplication_01-2020.pdf" data-original-title="" title=""><br>Pièce jointe</a></td></tr></tbody></table></div>
</div>
</div></div> </div>
</div>

<div class="col-sm-4">
  <div class="row accueil"><div class="col-sm-12">
<div class="card hide card-default">
<div class="card-header">
<div class="card-title"><strong>Mains courantes</strong></div>

</div>
<div class="card-body">
<div class="row accueil" style=""><a href="evenement_choice.php?ec_mode=MC&amp;page=1" data-original-title="" title=""><i class="fa fa-ellipsis-h fa-lg three-points-icon" data-original-title="" title=""></i></a><a href="evenement_choice.php?ec_mode=MC&amp;page=1" data-original-title="" title=""><i class="fa fa-ellipsis-h fa-lg three-points-icon" data-original-title="" title=""></i></a><table class="noBorder widget-table"><tbody><tr data-original-title="" title=""><td><img border="0" src="../../../assets/images/moyens/VLTT.png" width="40" title="" data-original-title="Main courante"></td><td class="widget-title" style="padding-left: 10px"><a href="evenement_display.php?pid=245&amp;from=default&amp;tab=1&amp;evenement=3770" data-original-title="" title="">suivi des véhicules  </a></td><td class="activity-date"><div class="widget-text">01-01-2021</div><span class="subtitle-small" data-original-title="" title="">08:00 à 17:00</span></td><td><a href="evenement_display.php?pid=245&amp;from=default&amp;tab=1&amp;evenement=3770" data-original-title="" title=""><i class="fas fa-arrow-right grey-button-arrow" data-original-title="" title=""></i></a></td></tr></tbody></table></div>
</div>
</div></div><div class="col-sm-12">
<div class="card hide card-default">
<div class="card-header">
<div class="card-title"><strong>Véhicule</strong></div>

</div>
<div class="card-body">
<div class="row accueil" style=""><a href="vehicule.php?page=1" data-original-title="" title=""><i class="fa fa-ellipsis-h fa-lg three-points-icon" data-original-title="" title=""></i></a><table class="noBorder widget-table"><tbody><tr data-original-title="" title=""><td class="alert-red alert-element"><div class="alert-justify"><div> <a class="widget-link" href="vehicule.php?order=TV_CODE&amp;filter=0&amp;TV_CODE=ALL&amp;subsections=1&amp;includeold=0&amp;order=VP_OPERATIONNEL" title="" data-original-title="Cliquer pour voir les véhicules"><span class="widget-title" data-original-title="" title="">Véhicules indisponibles</span></a></div><a class="widget-link" href="vehicule.php?order=TV_CODE&amp;filter=0&amp;TV_CODE=ALL&amp;subsections=1&amp;includeold=0&amp;order=VP_OPERATIONNEL" title="" data-original-title="Cliquer pour voir les véhicules"><span class="text-warning-alert" style="color:#f64e60" data-original-title="" title="">1</span></a></div></td></tr></tbody></table><table class="noBorder widget-table"><tbody><tr data-original-title="" title=""><td class="alert-orange alert-element"><div class="alert-justify"><div> <a class="widget-link" href="vehicule.php?order=TV_CODE&amp;filter=0&amp;TV_CODE=ALL&amp;subsections=1&amp;includeold=0&amp;order=DT_CT" title="" data-original-title="Cliquer pour voir les véhicules"><span class="widget-title" data-original-title="" title="">Contrôles techniques</span><span class="widget-subtitle" data-original-title="" title=""><br>Bientôt périmés</span></a></div><a class="widget-link" href="vehicule.php?order=TV_CODE&amp;filter=0&amp;TV_CODE=ALL&amp;subsections=1&amp;includeold=0&amp;order=DT_CT" title="" data-original-title="Cliquer pour voir les véhicules"><span class="text-warning-alert" style="color:#ffa800" data-original-title="" title="">1</span></a></div></td></tr></tbody></table><table class="noBorder widget-table"><tbody><tr data-original-title="" title=""><td class="alert-orange alert-element"><div class="alert-justify"><div> <a class="widget-link" href="vehicule.php?order=TV_CODE&amp;filter=0&amp;TV_CODE=ALL&amp;subsections=1&amp;includeold=0&amp;order=DT_REV" title="" data-original-title="Cliquer pour voir les véhicules"><span class="widget-title" data-original-title="" title="">Révisions</span><span class="widget-subtitle" data-original-title="" title=""><br>À faire</span></a></div><a class="widget-link" href="vehicule.php?order=TV_CODE&amp;filter=0&amp;TV_CODE=ALL&amp;subsections=1&amp;includeold=0&amp;order=DT_REV" title="" data-original-title="Cliquer pour voir les véhicules"><span class="text-warning-alert" style="color:#ffa800" data-original-title="" title="">1</span></a></div></td></tr></tbody></table></div>
</div>
</div></div><div class="col-sm-12">
<div class="card hide card-default">
<div class="card-header">
<div class="card-title"><strong>Demande de remplaçant</strong></div>

</div>
<div class="card-body">
<div class="row accueil" style=""><span class="no-content" data-original-title="" title="">Aucun recherche de remplaçant.</span><a href="remplacements.php" data-original-title="" title=""><i class="fa fa-ellipsis-h fa-lg three-points-icon" data-original-title="" title=""></i></a></div>
</div>
</div></div> -->


<!-- <div class="col-sm-12">
<div class="card hide card-default">
<div class="card-header">
<div class="card-title"><strong>Calendrier des activités</strong></div>
<div class="card-toolbar">
<ul class="nav nav-pills nav-pills-sm nav-dark-75 nav-pills-calendar" role="tablist"><li class="nav-item" data-original-title="" title="">
<a class="nav-link card-link active" data-toggle="tab" href="#" onclick="javascript:update_number_events('10')" ;="" data-original-title="" title="">
  <span class="nav-text font-size-sm card-button" title="" data-original-title="afficher au maximum 10 lignes">10</span>
</a>
</li><li class="nav-item" data-original-title="" title="">
<a class="nav-link card-link " data-toggle="tab" href="#" onclick="javascript:update_number_events('40')" ;="" data-original-title="" title="">
  <span class="nav-text font-size-sm card-button" title="" data-original-title="afficher au maximum 40 lignes">40</span>
</a>
</li></ul>
</div>
</div>
<div class="card-body">
<div class="row accueil" style=""><a href="evenement_choice.php?ec_mode=default&amp;page=1" data-original-title="" title=""><i class="fa fa-ellipsis-h fa-lg three-points-icon" data-original-title="" title=""></i></a><div class="widget-principal-subtitle">Centre de secours demo</div><table class="noBorder widget-table"></table></div>
</div>
</div></div> -->

<!-- 
<div class="col-sm-12">
<div class="card hide card-default">
<div class="card-header">
<div class="card-title"><strong>Note de frais</strong></div>

</div>
<div class="card-body">
<div class="row accueil" style=""><span class="no-content" data-original-title="" title="">Aucune note de frais à traiter</span></div>
</div>
</div></div><div class="col-sm-12">
<div class="card hide card-default">
<div class="card-header">
<div class="card-title"><strong>Heures de formation</strong></div>

</div>
<div class="card-body">
<div class="row accueil" style=""><a href="upd_personnel.php?pid=245&amp;type_evenement=FOR&amp;tab=4" data-original-title="" title="">
<i class="fa fa-ellipsis-h fa-lg three-points-icon" data-original-title="" title=""></i></a><span class="no-content" data-original-title="" title="">Formations suivies depuis le début 2021.</span><br><table class="noBorder widget-table"><tbody><tr data-original-title="" title=""><td class="widget-title">Secourisme </td><td class="widget-text">09:00 h</td></tr><tr data-original-title="" title=""><td class="widget-text" width="120"><b>TOTAL </b></td><td class="widget-text"><b> 09:00 h</b> <small>Stagiaire</small></td></tr></tbody></table></div>
</div>
</div></div>

<div class="col-sm-12">
  <div class="card hide card-default">
      <div class="card-header">
          <div class="card-title"><strong>A propos de eBrigade</strong></div>
          
      </div>
      <div class="card-body">
          <div class="row accueil" style=""><a href="about.php" data-original-title="" title=""><i class="fa fa-ellipsis-h fa-lg three-points-icon" data-original-title="" title=""></i></a><table class="noBorder widget-table separate"><tbody><tr data-original-title="" title=""><td class="alert-icon alert-blue" style="width: 40px;height: 40px;display: flex;justify-content: center;align-items: center"><i class="fa fa-book" style="font-size: 15px;" data-original-title="" title=""></i></td>
      <td class="widget-text" style="padding-left: 10px">Documentation en ligne</td>
      <td><a href="https://ebrigade.app/wp/document/" target="_blank" data-original-title="" title=""><i class="fas fa-arrow-right grey-button-arrow" title="" data-original-title="Voir la documentation en ligne"></i></a></td></tr><tr data-original-title="" title=""><td class="alert-icon alert-violet" style="width: 40px;height: 40px;display: flex;justify-content: center;align-items: center"><i class="fa fa-hands-helping" style="font-size: 15px;" data-original-title="" title=""></i></td>
      <td class="widget-text" style="padding-left: 10px">Communauté eBrigade</td>
      <td><a href="https://community.ebrigade.app" target="_blank" data-original-title="" title=""><i class="fas fa-arrow-right grey-button-arrow" title="" data-original-title="Accès à la communauté eBrigade"></i></a></td></tr><tr data-original-title="" title=""><td class="alert-icon alert-green-apple" style="width: 40px;height: 40px;display: flex;justify-content: center;align-items: center"><i class="fa fa-envelope" style="font-size: 15px;" data-original-title="" title=""></i></td>
      <td class="widget-text" style="padding-left: 10px">Support <a href="mailto:admin@ebrigade.org" data-original-title="" title="">admin@ebrigade.org</a></td>
      <td><a href="mailto:admin@ebrigade.org" data-original-title="" title=""><i class="fas fa-arrow-right grey-button-arrow" title="" data-original-title="Envoyer un email au webmaster"></i></a></td></tr><tr data-original-title="" title=""><td class="alert-icon alert-orange" style="width: 40px;height: 40px;display: flex;justify-content: center;align-items: center"><i class="fa fa-info" style="font-size: 15px;" data-original-title="" title=""></i></td>
      <td class="widget-text" style="padding-left: 10px">Vous utilisez ebrigade version<b> 5.3.0</b></td>
      <td><a href="configuration.php?tab=conf7" data-original-title="" title=""><i class="fas fa-arrow-right grey-button-arrow" title="" data-original-title="A propos ebrigade"></i></a></td></tr><tr data-original-title="" title=""><td class="alert-icon alert-grey" style="width: 40px;height: 40px;display: flex;justify-content: center;align-items: center"><i class="fa fa-globe" style="font-size: 15px;" data-original-title="" title=""></i></td>
      <td class="widget-text" style="padding-left: 10px">Pour plus d'informations : www.ebrigade.app</td>
      <td><a href="about.php" data-original-title="" title=""><i class="fas fa-arrow-right grey-button-arrow" title="" data-original-title="Visiter ebrigade.app"></i></a></td></tr></tbody></table></div>
      </div>
  </div></div>

   </div>
</div>

</div> -->




